import { UserDetail } from '../../../components/User';
import { UserType } from '../../../types';

export function InternalUser() {
  return <UserDetail type={UserType.Internal} />;
}
